import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export const PAGE_SIZE_QUERY_PARAM = 'size';
export const NANOSECONDS_IN_MILLISECOND = 1000000;
export const getHeaderWidths = params => {
  const {
    DATE_HEADER_WIDTH,
    CATEGORY_HEADER_WIDTH,
    TYPE_HEADER_WIDTH,
    ACTOR_HEADER_WIDTH
  } = params.showEventCategoryField ? {
    // Widths for audit logs page
    DATE_HEADER_WIDTH: 16,
    CATEGORY_HEADER_WIDTH: 16,
    TYPE_HEADER_WIDTH: 10,
    ACTOR_HEADER_WIDTH: 16
  } : {
    // Widths for integration-specific log page
    DATE_HEADER_WIDTH: 14,
    CATEGORY_HEADER_WIDTH: 0,
    // This category is not visible in this page
    TYPE_HEADER_WIDTH: 12,
    ACTOR_HEADER_WIDTH: 22
  };
  const columnsToShow = [DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH, ...(getBooleanFF('platform.pun.audit-logs-actor-column_sxmw6') ? [ACTOR_HEADER_WIDTH] : [])];
  let sum = 0;
  columnsToShow.forEach(width => {
    sum += width;
  });
  return {
    DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
    CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
    TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
    ACTOR_HEADER_WIDTH: `${ACTOR_HEADER_WIDTH}%`,
    CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
  };
};
export const DETAIL_ITEM_BASE_WIDTH = 250;